// Simple event emitter to replace Vue 2's new Vue() event bus pattern
class EventEmitter {
  constructor() {
    this.events = {};
  }

  $on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  $off(event, callback) {
    if (!this.events[event]) return;
    if (callback) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    } else {
      delete this.events[event];
    }
  }

  $emit(event, ...args) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback(...args));
  }

  $once(event, callback) {
    const wrapper = (...args) => {
      callback(...args);
      this.$off(event, wrapper);
    };
    this.$on(event, wrapper);
  }
}

export default EventEmitter;
